import { FC } from "react";
import { Select } from "antd";
import { GuestSelectFieldProps } from "../GuestSelectField";

const GuestSelectFieldWeb: FC<GuestSelectFieldProps> = ({ value, onChange, placeholder, options, showSearch }) => {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      className="p-2!"
      showSearch={showSearch ? { optionFilterProp: "label" } : undefined}
    />
  );
};

export default GuestSelectFieldWeb;
